/* Moomo R2 · Promo marquee — pause/play button + reduced-motion crossfade. The scrolling itself is pure CSS. */
(() => {
  const init = (root) => {
    if (root.dataset.mmReady) return;
    root.dataset.mmReady = '1';
    root.classList.add('is-js');
    const btn = root.querySelector('[data-mm-mq-toggle]');
    const slides = [...root.querySelectorAll('.mm-mq__slide')];
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    let i = 0;
    let timer = null;

    // the duplicated set must never take keyboard focus
    root.querySelectorAll('[data-mm-mq-copy] a').forEach((a) => a.setAttribute('tabindex', '-1'));

    const paused = () => btn.getAttribute('aria-pressed') === 'true';
    const show = (n) => slides.forEach((s, k) => s.classList.toggle('is-active', k === n));
    const stop = () => { clearInterval(timer); timer = null; };
    const start = () => {
      stop();
      if (!reduce.matches || paused() || slides.length < 2) return;
      timer = setInterval(() => { i = (i + 1) % slides.length; show(i); }, 5000);
    };

    btn.addEventListener('click', () => {
      const p = !paused();
      btn.setAttribute('aria-pressed', String(p));
      btn.setAttribute('aria-label', p ? 'Play promotions' : 'Pause promotions');
      root.classList.toggle('is-paused', p);
      start();
    });
    // crossfade also holds while the pointer or keyboard focus is on the strip
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', (e) => { if (!root.contains(e.relatedTarget)) start(); });
    reduce.addEventListener('change', start);
    start();
  };

  const boot = () => document.querySelectorAll('[data-mm-marquee]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
